export const SET_CORPORATE_SIGNATURES = (state, payload) => {
  state.corporateSignatures = payload;
};
